import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetPatientQuery } from "@store/patientApi";
import Loader from "@components/Loader/Loader";
import OnboardingPicturesUpload from "@components/Onboarding/OnboardingPicturesUpload/OnboardingPicturesUpload";
import {
  isAddPatientFlow,
  withOnboardingFlow,
} from "@components/Onboarding/onboardingFlow";

const Pictures: FC = () => {
  const patientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const { id } = useParams();
  const accountId = useSelector((state: RootState) => state.account.accountId);
  const navigate = useNavigate();
  const location = useLocation();
  const isPatientOnlyFlow = isAddPatientFlow(location.search);
  const effectivePatientId = id || (isPatientOnlyFlow ? null : patientId);
  const { data: patient, isLoading } = useGetPatientQuery(effectivePatientId!, {
    skip: !effectivePatientId,
  });

  useEffect(() => {
    if (!accountId) {
      navigate("/onboarding");
    } else if (!patient && !isLoading) {
      navigate(withOnboardingFlow("/onboarding/profile", location.search));
    }
  }, [patient, navigate, accountId, isLoading, location.search]);

  return (
    <>
      {isLoading || !patient ? (
        <Loader />
      ) : (
        <OnboardingPicturesUpload patient={patient} />
      )}
    </>
  );
};

export default Pictures;
